import './bottomContent.scss';

function BottomContent() {
  return (
    <div className="bottomContent">
      <div className="nftHolder">
        <div className="nft1"></div>
        <div className="nft2"></div>
        <div className="nft3"></div>
      </div>
      {/* <a href="https://opensea.io/collection/strangeodyssey" target={'_blank'} className="button">
        <div>View Collection In OpenSea</div>
      </a> */}
      <a href="https://etherscan.io/address/0x1081f2c6ef001384cfaf2e71e3b7f3c6e3d2b28b" target={'_blank'} rel="noreferrer" className="button">
        <div>View ERC-721a Contract</div>
      </a>
    </div>
  );
}

export default BottomContent;
